import { render } from "./Location.vue?vue&type=template&id=26e64548&ts=true"
import script from "./Location.vue?vue&type=script&lang=ts"
export * from "./Location.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/widget.surveybot.me/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__